NIRV.refreshNorth = function () {
  DEBUG && console.log(' NIRV.refreshNorth()');

  if (NIRV.q) return;

  NIRV.autosave = false;

  var logo =
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 115 9.8" enable-background="new 0 0 115 9.8" xml:space="preserve"><path d="M9.9 0h1.8v9.8H9.9L1.8 2.3l0 1.5v6.1H0V0h1.8l8.1 7.5 0-1.5V0zM19.1 0h1.8v9.8h-1.8V0zM28.3 0h7.8c2.1 0 3.8 0.8 3.8 3.2 0 2.3-1.7 3.1-3.8 3.1h-0.4l4.5 3.6h-2.8l-4.3-3.5h-3.1v3.5h-1.8V0zM36.1 4.6c1.1 0 1.9-0.4 1.9-1.5 0-1.1-0.8-1.5-1.9-1.5h-6v2.9H36.1zM63.3 9.8L69 0l2.1 0 5.7 9.8h-2.1l-2.4-4.2 -2.3-4 -2.3 4 -2.4 4.2H63.3zM101.4 9.8l5.7-9.8 2.1 0 5.7 9.8h-2.1l-2.4-4.2 -2.3-4 -2.3 4 -2.4 4.2H101.4zM59.5 0l-5.7 9.8h-2.1L45.9 0H48l2.4 4.2 2.3 4 2.3-4L57.4 0H59.5zM93.2 0H95v9.8h-1.8L85 2.3l0 1.5v6.1h-1.8V0h1.8l8.1 7.5 0-1.5V0z"/></svg>';

  var focus_q = function () {
    return NIRV.q == '' ? '' : 'focus';
  };

  var currentarea = NIRV.currentarea;
  if (NIRV.currentarea == '__ALL__') currentarea = NIRV.L.all_areas;
  if (NIRV.currentarea == '__NONE__') currentarea = NIRV.L.unassigned;

  $('#north').empty();
  $('#north').append('<span class="left"></span>');

  var areamenu_vibility = NIRV.areas().length > 0 ? 'visible' : 'hidden';
  var highlight = NIRV.currentarea == '__ALL__' ? '' : 'attention';

  var html = '';

  // -- col 1 ---
  html += '<span class="left">';

  // NIRVANA LOGO
  html += '<span class="logo">' + logo + '</span>';

  // AREA MENU
  html += '<span class="area x_currentarea xcmenu ' + highlight + '"';
  html += ' style="visibility:' + areamenu_vibility + ';">';
  html += currentarea;
  html += '</span>';

  html += '</span>';

  // -- col 2 ---
  // NEW ITEM
  html += '<a class="button newtask multibutton">';
  html += NIRV.L.new_item + ' ';
  html += '<span class="xcmenu"><span class="chev">▾</span></span>';
  html += '</a>';

  // SEARCH BAR
  html += '<form class="search" action="#" method="get"';
  html += ' onsubmit="return false;">';
  html += '<input type="text" class="q ' + focus_q() + '"';
  html += ' name="q" value="' + NIRV.q + '"';
  html += ' autocomplete="off" placeholder="' + NIRV.L.search + '"';
  html += ' tabindex="-1">';
  html += '<i class="search-icon"></i>';
  html += '</form>';

  // SETTINGS
  if (NIRV.user.firstname || NIRV.user.lastname) {
    html += '<a class="right button settingsmenu xcmenu">';
    html += NIRV.user.firstname + ' ' + NIRV.user.lastname;
    // html += NIRV.user.emailaddress;
    // html += 'Settings';
    html += '</a>';
  } else {
    html += '<a class="right button settingsmenu xcmenu">' + NIRV.L.settings + '</a>';
  }

  // UPGRADE
  if (NIRV.user.servicelevel == 'basic') {
    html += '<a class="right button upgrade">';
    html += '<span class="upgrade">' + NIRV.L.upgrade + '</span>';
    html += '</a>';
  }

  // REFRESH
  html += '<a class="right button sync">';
  html += '<span>' + NIRV.L.refresh + '</span>';
  html += '<span class="status">•</span>';
  html += '</a>';

  // CLEANUP
  html += '<a class="right button cleanup"';
  html += ' title="' + NIRV.L.tooltip_cleanup + '">';
  html += '<span>' + NIRV.L.cleanup + '</span><span class="count"></span>';
  html += '</a>';

  $('#north').html(html);

  NIRV.autosave = true;
};

NIRV.renderSettingsMenu = function () {
  var html = '';
  html += '<ul class="sf-menu">';
  html += '   <li>';
  html += '      <a href="#" class="cmenu submenu">&nbsp;</a>';
  html += '      <ul>';
  html += '         <li><span class="label">' + NIRV.L.nirvana + '</span></li>';
  html +=
    '         <li><a href="#" fn="NIRV.appSettings">' + NIRV.L.preferences + '...<span class="hotkey">comma</span></a></li>';
  html +=
    '         <li><a href="#" fn="NIRV.manageTags">' + NIRV.L.manage_tags + '<span class="hotkey">G</span></a></li>';
  html +=
    '         <li><a href="#" fn="NIRV.gotoAccount" p1="dashboard">' + NIRV.L.my_account + '</a></li>';
  html += '         <li><span class="divider"></span></li>';
  html += '         <li><span class="label">' + NIRV.L.help + '</span></li>';
  html +=
    '         <li><a href="#" fn="NIRV.gettingStarted">' + NIRV.L.getting_started + '<span class="hotkey">H</span></a></li>';
  html +=
    '         <li><a href="#" fn="NIRV.keyboardShortcuts">' + NIRV.L.keyboard_shortcuts + '<span class="hotkey">K</span></a></li>';
  html +=
    '         <li><a href="' +
    NIRV.baseurl_www + (NIRV.prefs?.UILanguage?.value || '') + 
    '/contact" rel="external" target="_blank">' + NIRV.L.ask_us_question + '</a></li>';
  html +=
    '         <li><a href="' +
    NIRV.baseurl_www +
    'go/blog" rel="external" target="_blank">' + NIRV.L.visit_blog + '</a></li>';
  html += '         <li><span class="divider"></span></li>';
  html += '         <li><a href="#" fn="NIRV.logout">' + NIRV.L.logout + '</a></li>';
  html += '      </ul>';
  html += '   </li>';
  html += '</ul>';
  return html;
};

NIRV.gettingStarted = function () {
  NIRV.highlight_tasks(false);

  var html = '';

  html += '<div id="gettingstarted">';

  html += '<h2>' + NIRV.L.hello + '</h2>';
  html += '<p>' + NIRV.L.orientation_intro + '</p>';
  
  html += '<ul>';
  html +=
    '<li>' + NIRV.L.orientation_point_1 + '</li>';
  html +=
    '<li>' + NIRV.L.orientation_point_2 + '</li>';
  html +=
    '<li>' + NIRV.L.orientation_point_3 + '</li>';
  html +=
    '<li>' + NIRV.L.orientation_point_4 + '</li>';
  html +=
    '<li>' + NIRV.L.orientation_point_5 + '</li>';
  html += '</ul>';
  
  html += '<h2>' + NIRV.L.email_to_inbox + '</h2>';
  html +=
    '<p>' + NIRV.L.email_inbox_description + ' <a rel="external" href="mailto:Nirvana%20Inbox%3C' +
    NIRV.user.inmailaddress +
    '@nirvanahq.in%3E?subject=New%20Item%20via%20Email&body=Save%20this%20address%20to%20your%20Address%20Book%20so%20you%20can%20easly%20email%20tasks%20to%20Nirvana%20in%20the%20future.%0A%0ATIPS%3A%0A%0A-%20The%20email%20subject%20becomes%20the%20task%20name.%0A-%20Any%20notes%20you%27d%20like%20to%20attach%20to%20your%20task%20should%20go%20in%20the%20email%20body.%0A-%20Email%20must%20be%20less%20than%20100%20kb.%20%20Attachments%20are%20stripped.%0A%0AGive%20it%20a%20try...%20Click%20Send%20to%20post%20a%20new%20task%20to%20your%20Nirvana%20Inbox%20with%20the%20contents%20of%20this%20email.">' +
    NIRV.user.inmailaddress +
    '@nirvanahq.in</a></p>';
  html += '   <h2>' + NIRV.L.go_deeper + '</h2>';
  html +=
    "   <p>" + NIRV.L.quick_guide_description.replace('{url}', NIRV.baseurl_www) + "</p>";
  html += '</div>';

  var options = {
    autoOpen: false,
    closeOnEscape: true,
    closeText: NIRV.L.done,
    dialogClass: 'gettingstarted',
    title: NIRV.L.getting_started + ' ',
    width: 720,
    position: NIRV.dialog_position_default,
    modal: true,
    resizable: false,
    buttons: {
      [NIRV.L.done]: function () {
        $(this).dialog('close');
      },
    },
  };
  // $('#dialog').dialog('destroy');
  $('#dialog').html(html);
  $('#dialog').dialog(options);
  $('#dialog').dialog('open');
};

NIRV.keyboardShortcuts = function () {
  NIRV.highlight_tasks(false);

  var html = '';

  html += '<div id="keyboardshortcuts">';
  html += '  <table>';
  html += "    <tr valign='top'>";
  html += "      <td style='padding-right: 25px;'>";

  html += "        <ul>";
  html += "          <li class='label'><h4>" + NIRV.L.create_new_ellipsis + "</h4></li>";
  html += "          <li><h5>" + NIRV.L.item_in_current_list + "</h5> <div class='keys'><i>n</i></div></li>";
  html += "          <li><h5>" + NIRV.L.item_in_current_list_at_top + "</h5> <div class='keys'><i>shift</i><i>n</i></div></li>";
  html += "          <li class='label'></li>";
  html += "          <li><h5>" + NIRV.L.action_in_inbox + "</h5> <div class='keys'><i>i</i></div></li>";
  html += "          <li class='label'></li>";
  html += "          <li><h5>" + NIRV.L.action_in_next + "</h5> <div class='keys'><i>x</i></div></li>";
  html += "          <li><h5>" + NIRV.L.action_in_waiting + "</h5> <div class='keys'><i>w</i></div></li>";
  html += "          <li><h5>" + NIRV.L.action_in_scheduled + "</h5> <div class='keys'><i>s</i></div></li>";
  html += "          <li><h5>" + NIRV.L.action_in_someday + "</h5> <div class='keys'><i>y</i></div></li>";
  html += "          <li class='label'></li>";
  html += "          <li><h5>" + NIRV.L.action_in_focus + "</h5> <div class='keys'><i>f</i></div></li>";
  html += "          <li class='label'></li>";
  html += "          <li><h5>" + NIRV.L.project + "</h5> <div class='keys'><i>p</i></div></li>";
  html += "          <li><h5>" + NIRV.L.reference_list + "</h5> <div class='keys'><i>l</i></div></li>";
  html += "        </ul>";

  html += "        <ul>";
  html += "          <li class='label'><h4>" + NIRV.L.navigation + "</h4></li>";
  html += "          <li><h5>" + NIRV.L.inbox_through_trash + "</h5> <div class='keys'><i>1</i> ... <i>9</i>, <i>0</i></div></li>";
  html += "          <li><h5>" + NIRV.L.traverse_up_down + "</h5> <div class='keys'><i>[</i>, <i>]</i></div></li>";
  html += "        </ul>";

  html += "      </td>";
  html += "      <td>";

  html += "        <ul>";
  html += "          <li class='label'><h4>" + NIRV.L.filtering_by_area + "</h4></li>";
  html += "          <li><h5>" + NIRV.L.all_areas + "</h5> <div class='keys'><i>shift</i><i>0</i></div></li>";
  html += "          <li><h5>" + NIRV.L.next_area + "</h5> <div class='keys'><i>shift</i><i>]</i></div></li>";
  html += "          <li><h5>" + NIRV.L.previous_area + "</h5> <div class='keys'><i>shift</i><i>[</i></div></li>";
  html += "          <li><h5>" + NIRV.L.unassigned + "</h5> <div class='keys'><i>shift</i><i>9</i></div></li>";
  html += "        </ul>";

  html += "        <ul>";
  html += "          <li class='label'><h4>" + NIRV.L.more_goodies + "</h4></li>";
  html += "          <li><h5>" + NIRV.L.search + "</h5> <div class='keys'><i>/</i></div></li>";
  html += "          <li><h5>" + NIRV.L.cleanup + "</h5> <div class='keys'><i>c</i></div></li>";
  html += "          <li><h5>" + NIRV.L.refresh + "</h5> <div class='keys'><i>r</i></div></li>";
  html += "          <li><h5>" + NIRV.L.manage_tags + "</h5> <div class='keys'><i>g</i></div></li>";
  html += "          <li><h5>" + NIRV.L.app_preferences + "</h5> <div class='keys'><i>,</i></div></li>";
  html += "          <li><h5>" + NIRV.L.close_window_cancel + "</h5> <div class='keys'><i>esc</i></div></li>";
  html += "        </ul>";

  html += "        <ul>";
  html += "          <li class='label'><h4>" + NIRV.L.help + "</h4></li>";
  html += "          <li><h5>" + NIRV.L.getting_started_hotkey + "</h5> <div class='keys'><i>h</i></div></li>";
  html += "          <li><h5>" + NIRV.L.keyboard_shortcuts_this_screen + "</h5> <div class='keys'><i>k</i></div></li>";
  html += "        </ul>";

  html += "      </td>";
  html += "    </tr>";
  html += "  </table>";
  html += "</div>";

  var options = {
    autoOpen: false,
    closeOnEscape: true,
    closeText: NIRV.L.done,
    dialogClass: 'gettingstarted',
    title: NIRV.L.keyboard_shortcuts,
    height: 'auto',
    width: 'auto',
    position: NIRV.dialog_position_default,
    modal: true,
    resizable: false,
    buttons: {
      [NIRV.L.done]: function () {
        $(this).dialog('close');
      },
    },
  };
  // $('#dialog').dialog('destroy');
  $('#dialog').html(html);
  $('#dialog').dialog(options);
  $('#dialog').dialog('open');
};

NIRV.toggleSidebarHelp = function () {
  if ($('#help:visible').length == 1) {
    NIRV.setPref('UIBShowSidebarHelp', 0, true);
    $('#help').fadeOut(100);
  } else {
    NIRV.setPref('UIBShowSidebarHelp', 1, true);
    $('#help').fadeIn(100);
  }
};

NIRV.showDiagnostics = function () {
  NIRV.highlight_tasks(false);

  var diagnostics = NIRV.diagnostics();

  var html = '';
  html += '<div class="content">';
  html += '   <textarea>\n\n*Diagnostics/Snapshot*\n\n';

  for (var i in diagnostics) {
    html += i.toUpperCase() + ' ' + diagnostics[i] + '\n';
  }
  html += '\n\n';

  html += '--------------------------------------------------------------\n\n';

  // STALE TASKS
  for (var i in NIRV.tasks) {
    if (NIRV.tasks[i] != undefined && NIRV.tasks[i].__stale__) {
      for (var s in NIRV.tasks[i]) {
        if (s[0] == '_' && s[1] != '_' && NIRV.tasks[i][s] > NIRV.since) {
          html += i + ' ' + NIRV.tasks[i][s] + ' ' + s + '\n';
        }
      }
    }
  }

  // STALE TAGS
  for (var i in NIRV.tags) {
    if (NIRV.tags[i].__stale__) {
      for (var s in NIRV.tags[i]) {
        if (s[0] == '_' && s[1] != '_' && NIRV.tags[i][s] > NIRV.since) {
          html += md5(i) + ' ' + NIRV.tags[i][s] + ' ' + s + '\n';
        }
      }
    }
  }

  // STALE PREFS
  for (var i in NIRV.prefs) {
    if (NIRV.prefs[i].__stale__) {
      for (var s in NIRV.prefs[i]) {
        if (s[0] == '_' && s[1] != '_' && NIRV.prefs[i][s] > NIRV.since) {
          html += i + ' ' + NIRV.prefs[i][s] + ' ' + s + '\n';
        }
      }
    }
  }

  html += '\n';

  // ILLEGAL TAGS
  for (var i in NIRV.tags) {
    if (i.indexOf('&amp;') != -1) {
      html +=
        'AFFECTED BY AMPERSAND BUG ' + NIRV.tags[i].type + ' ' + md5(i) + '\n';
    }
    if (i.indexOf('"') != -1) {
      html +=
        'AFFECTED BY DBLQUOTES BUG ' + NIRV.tags[i].type + ' ' + md5(i) + '\n';
    }
  }

  // ILLEGAL TAGS AFFECTING TASKS
  for (var i in NIRV.tasks) {
    if (
      NIRV.tasks[i] != undefined &&
      NIRV.tasks[i].tags.indexOf('&amp;') != -1
    ) {
      html += 'AFFECTED BY AMPERSAND BUG ' + i + '\n';
    }
    if (NIRV.tasks[i] != undefined && NIRV.tasks[i].tags.indexOf('"') != -1) {
      html += 'AFFECTED BY DBLQUOTES BUG ' + i + '\n';
    }
  }

  html += '\n';
  html += '\n';

  html += '   </textarea>';
  html += '</div>';

  var options = {
    autoOpen: false,
    dialogClass: 'diagnostics',
    title: NIRV.L.n2_current_state_snapshot,
    height: 'auto',
    width: 640,
    modal: true,
    resizable: false,
    buttons: {
      [NIRV.L.send_to_dev_team]: function () {
        location.href =
          'mailto:devteam@nirvanahq.com?subject=' +
          escape('Problem Report - Diagnostics') +
          '&body=' +
          escape(
            '\n\n\n--------------------------------------------------------------\nPlease describe the nature of the problem above\n\n' +
              $('#dialog textarea').val()
          );
        $(this).dialog('close');
      },
      [NIRV.L.cancel]: function () {
        $(this).dialog('close');
      },
    },
  };
  // $('#dialog').dialog('destroy');
  $('#dialog').html(html);
  $('#dialog').dialog(options);
  $('#dialog').dialog('open');
};
